import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { TosGateModal, useTosGate } from './TosGate';

export default function RequireAuth() {
  const { isAuthenticated, initializing } = useAuth();
  const location = useLocation();
  // RAM-215 originally also gated on license status here, BEFORE the TOS gate below (a licensing
  // failure was treated as more fundamental than TOS acceptance -- see the removed
  // LicenseGate.tsx's own comment for that reasoning). Per direct product-owner direction
  // (2026-08-08, "non-blocking banner"): the license gate is REMOVED entirely -- the app is
  // reachable regardless of license state. License status is now surfaced via a persistent,
  // dismissible banner (LicenseStatusBanner.tsx, mounted in Layout.tsx) instead of blocking here.
  // This is a deliberate reversal of RAM-215's blocking behavior, not a bug in the old design --
  // the real security enforcement was always the backend's own tenant/license checks
  // (require_license_tenant_match, Fabric's license_gate middleware), never this UI gate.
  // The TOS gate below is completely unaffected by this change.
  const { status: tosStatus, loading: tosLoading, blocked: tosBlocked } = useTosGate();

  if (initializing) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;
  if (tosLoading) return null;
  if (tosBlocked && tosStatus) return <TosGateModal status={tosStatus} />;
  return <Outlet />;
}
